import classplusLogo from "../../assets/Images/classplus-logo.png";
import classplusLogoColored from "../../assets/Images/classplus-logo-colored.png";
// import appImage from "../../assets/Images/app-image.png";
import facebook from "../../assets/Images/facebook.png";
import instagram from "../../assets/Images/instagram.png";
import youtube from "../../assets/Images/youtube.png";
import linkedin from "../../assets/Images/linkedin.png";
import twitter from "../../assets/Images/twitter.png";

import "./thankyou.css";
import KnowMoreSection from "../../components/KnowMoreSection";

const ThankYouScreen = () => {
  return (
    <div className="thank_you_screen">
      <div className="thank_you_banner">
        <img
          className="logo"
          width={150}
          src={classplusLogo}
          alt="classplus-logo"
        />
        <p className="thank_you">Thank you for trusting us</p>
        <p className="thank_you_text">
          Our Growth executive will get in touch with you soon.
        </p>
      </div>

      <div className="knowMoreContainer">
        <KnowMoreSection />
      </div>

      {/* <div className="rectangle_1">
        
      </div> */}

      {/* <div>
        <p className="text_still_not_impressed">still not impressed?</p>
        <p className="text_customer_review">Don’t take our words, check what our customers have to say.</p>
      </div>
      
      <div className="rectangle_2">
        <p className="text_need_assurance">NEED MORE ASSURANCE?</p>
        <p className="text_media_appreciation">Classplus is appreciated by National and International Media</p>
      </div> */}

      <div className="thank_you_footer">
        <img
          className="logo-colored"
          src={classplusLogoColored}
          alt="classplus-logo-colored"
        />

        <div className="iconsContainer">
          <div className="contact_me">
            <a
              href="https://classplusapp.com/contact"
              rel="noreferrer"
              className="text_contact_us"
              target="_blank"
            >
              Contact Us
            </a>
          </div>

          <div className="sm_links">
            <a href="https://www.facebook.com/classplusapp">
              <img className="footer-sm-image" src={facebook} alt="facebook" />
            </a>
            <a href="https://www.instagram.com/classplusculture">
              <img className="footer-sm-image" src={instagram} alt="facebook" />
            </a>
            <a href="https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA">
              <img className="footer-sm-image" src={youtube} alt="facebook" />
            </a>
            <a href="https://www.linkedin.com/company/classplus">
              <img className="footer-sm-image" src={linkedin} alt="facebook" />
            </a>
            <a href="https://twitter.com/classplusapps">
              <img className="footer-sm-image" src={twitter} alt="facebook" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouScreen;
